import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useModal from "@hooks/ModalHook";
import { ShareInputs } from "@components/ShareInputs";
import { useApi } from "@hooks/ApiHook";
import useAlert from "@hooks/AlertHook";
import { useWasmX } from "@hooks/WasmXHook";
import { ShareRequest } from "wasmx";
import { useTxModal } from "@hooks/TxModalHook";
import { CollectionResponse } from "baaanggg";
import { TxInfo } from "@terra-money/terra.js";
import { MsgExecuteContract } from "@goblinhunt/cosmes/client";
import { useWallet } from "@providers/wallet.provider";

type Props = {
  collection: CollectionResponse;
  onSaved: () => void;
};

function MintSharesModal({
  onSaved,
  collection: { collectionContract, id, ownerAddress },
}: Props) {
  const { showModal, closeModal, modalId } = useModal();
  const { data } = useApi((api) => api.collection.mintShares(id), [id]);
  const [shares, setShares] = useState<{ [key: string]: number }>({});
  const alert = useAlert();
  const txModal = useTxModal();
  const { wallet } = useWallet();
  useEffect(
    () =>
      setShares(
        data?.reduce(
          (prev, curr) => ({ ...prev, [curr.address]: curr.percentage * 100 }),
          {}
        ) ?? {}
      ),
    [data]
  );

  const onSubmit = async () => {
    closeModal();

    try {
      if (!wallet)
        throw new Error(
          "Cannot get information from blockchain, try refresh the page"
        );

      const message = new MsgExecuteContract({
        contract: collectionContract,
        sender: ownerAddress,
        msg: {
          set_mint_shares: {
            shares: Object.entries(shares).map<ShareRequest>(
              ([address, percentage]) => ({
                address,
                percentage: (percentage / 100).toString(),
              })
            ),
          },
        },
        funds: [],
      });

      await txModal.show([message], "Update Tx Shares", {
        onSuccess: async (tx) => {
          try {
            alert.loading("Sign Tx");
            await wallet!.pollTx(tx, {
              maxAttempts: 120_000,
              intervalSeconds: 15,
            });
          } catch (e) {
            // kalau mau, tampilkan warning tapi lanjut refresh
            console.warn("poll failed", e);
          }
          onSaved();
          alert.success("Bid accepted successfully");
        },
        onError: (er) => alert.failed(er.message),
      });
    } catch (e) {
      if (e instanceof Error) alert.failed(e.message);
    }
  };

  return (
    <>
      <Modal
        show={showModal && modalId === "mint-shares"}
        dialogClassName="max-w-3xl"
      >
        <Modal.Header>
          <Modal.Title>Minting Shares</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={() => closeModal()}
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              className="h-6 w-6 fill-jacarta-700 dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className="p-6">
          <div>
            <label className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white">
              Mint Shares
            </label>
            <ShareInputs
              shares={shares}
              creator={ownerAddress}
              onChange={(shares) => setShares(shares)}
            />
          </div>

          <button
            onClick={onSubmit}
            className="ml-auto mt-5 rounded-full bg-accent px-8 py-3 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
          >
            Update
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MintSharesModal;
